import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "up",
  "use": "up-usage",
  "viewBox": "0 0 90 90",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 90 90\" id=\"up\">\n  <path d=\"M44.744 25.01a3.635 3.635 0 0 0-2.186.91L6.215 58.627A3.65 3.65 0 1 0 11.1 64.05L45 33.529 78.901 64.05a3.648 3.648 0 1 0 4.884-5.423L47.442 25.919a3.635 3.635 0 0 0-2.698-.908Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol